export default __webpack_public_path__ + "static/media/farol-hq-easee.cc7bbdc5.png";